import axios from "axios";
import swal from "sweetalert2";
import parse from "html-react-parser";

import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl, isPremium } from "../utils/config";

import Loader from "./layouts/Loader";

function JobDetail() {
    const { id } = useParams();
    const [job, setJob] = useState(null);
    const [loading, setLoading] = useState(false);
    const [applying, setApplying] = useState(false);
    const [state, setState] = useState(globalState.state);
    const [cvs, setCvs] = useState([]);
    const [applications, setApplications] = useState([]);
    const [searchApplicants, setSearchApplicants] = useState("");
    const [anyApplicantChecked, setAnyApplicantChecked] = useState(false);
    const [downloadingCVs, setDownloadingCVs] = useState(false);
    const [following, setFollowing] = useState(false);
    const [isFollowing, setIsFollowing] = useState(false);

    async function toggleFollow() {
        setFollowing(true);

        try {
            const formData = new FormData();
            formData.append("id", job?.user?.id);
            formData.append("type", "recruiter");

            const response = await axios.post(
                baseUrl + "/api/followers/toggle",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setIsFollowing(!isFollowing);
                // swal.fire("Follow", response.data.message, "success");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);

            if (exp.response?.status == 401) {
                swal.fire("Error", "Un-authorized.", "error");
            }
        } finally {
            setFollowing(false);
        }
    }

    async function downloadCVs() {
        setDownloadingCVs(true);

        try {
            const formData = new FormData();
            formData.append("id", id);

            const applicationIds = [];
            const checked = document.querySelectorAll("input[type='checkbox'].application:checked");
            for (let a = 0; a < checked.length; a++) {
                applicationIds.push(checked[a].value);
            }
            formData.append("application_ids", JSON.stringify(applicationIds));

            if (isPremium) {
                const response = await axios.post(
                    baseUrl + "/api/jobs/download-cvs",
                    formData,
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                        }
                    }
                );

                swal.fire("Error", response.data.message, "error");
            } else {
                const response = await axios.post(
                    baseUrl + "/api/jobs/download-cvs",
                    formData,
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                        },
                        responseType: "blob"
                    }
                );

                const disposition = response.headers['content-disposition'];
                let filename = 'downloaded_file';

                if (disposition && disposition.indexOf('filename=') !== -1)
                {
                    const matches = /filename="?([^"]+)"?/.exec(disposition);
                    if (matches != null && matches[1])
                    {
                        filename = matches[1];
                    }
                }

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename); // or use dynamic name
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setDownloadingCVs(false);
        }
    }
    
    async function fetch() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("id", id);
            formData.append("time_zone", timeZone);
            formData.append("search", searchApplicants);

            const response = await axios.post(
                baseUrl + "/api/jobs/fetch-single",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    },

                    withCredentials: true
                }
            );

            if (response.data.status == "success") {
                setJob(response.data.job);
                setCvs(response.data.cvs);
                setApplications(response.data.applications);
                setIsFollowing(response.data.is_following);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    async function apply() {
        setApplying(true);

        try {
            const form = document.getElementById("form-apply");
            const formData = new FormData(form);
            formData.append("id", id);

            const response = await axios.post(
                baseUrl + "/api/jobs/apply",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const temp = { ...job };
                temp.applications++;
                setJob(temp);
                
                swal.fire("Apply", response.data.message, "success");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setApplying(false);
        }
    }

    async function changeApplicationStatus(id, status) {
        try {
            const formData = new FormData();
            formData.append("id", id);
            formData.append("status", status);

            const response = await axios.post(
                baseUrl + "/api/jobs/change-application-status",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                // swal.fire("Status Changed", response.data.message, "success");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        }
    }

    useEffect(function () {
        fetch();

        globalState.listen(function (newState, updatedState) {
            setState(newState);
        });
    }, []);

    const styles = {
        logo: {
            width: "80px",
            height: "80px",
            marginRight: "20px"
        },
        profileImage: {
            width: "100px",
            height: "100px",
            marginRight: "10px"
        },
        bgWhite: {
            backgroundColor: "white"
        },
        featureContainer: {
            background: "rgb(239 254 245)",
            padding: "30px",
            borderRadius: "12px",
            textAlign: "center",
            maxWidth: "600px",
            marginTop: "0px",
            marginBottom: "40px",
            marginLeft: "auto",
            marginRight: "auto",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
        },
        featureHeading: {
            color: "#2c3e50",
            fontSize: "32px",
            marginBottom: "15px"
        },
        featureContent: {
            color: "#555",
            fontSize: "18px",
            lineHeight: "1.6",
            maxWidth: "500px",
            margin: "0 auto"
        }
    };

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">{ job?.title }</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/jobs">Jobs</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">{ job?.title }</li>
                        </ol>
                    </nav>
                </div>
            </div>

            { loading && (
                <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="container">
                        <div className="row gy-5 gx-4">
                            <div className="col-md-12 text-center">
                                <Loader />
                            </div>
                        </div>
                    </div>
                </div>
            ) }

            { job != null && (
                <div className="container-xxl py-0 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="container">

                        { (state.user?.id == job.user.id && job.is_featured == 0) && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div style={ styles.featureContainer }>
  
                                        <h1 style={ styles.featureHeading }>
                                            🚀 Hiring fast? Feature your job and reach top candidates today!
                                        </h1>
                                          
                                        <p style={ styles.featureContent }>
                                            Feature your job to appear on the homepage and at the top of search results for 30 days. <strong>3× more visibility</strong>. <strong>Faster hires</strong>. Get the attention your job deserves!
                                        </p>

                                        <Link to={ `/jobs/${ job.id }/feature` } 
                                            className={ isPremium ? "btn btn-primary mt-3" : "btn btn-primary premium-bg premium-border mt-3" }>
                                            ✨ Feature My Job Now - ${ job.feature_price_per_month } for 30 days
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ) }

                        <div className="row gy-5 gx-4">
                            <div className="col-lg-8">
                                <div className="row">
                                    <div className="col-md-10">
                                        <div className="d-flex align-items-center mb-5">

                                            { job.user.profile_image && (
                                                <img className="flex-shrink-0 img-fluid border rounded"
                                                    src={ job.user.profile_image } alt=""
                                                    style={ styles.logo } />
                                            ) }

                                            <div className="text-start">
                                                <h3 className="mb-3 mb-0">{ job.title }</h3>

                                                { job.user != null && (
                                                    <p>
                                                        <Link to={ `/recruiter/${ job.user.id }` }>
                                                            { job.user.name }
                                                        </Link>
                                                    </p>
                                                ) }

                                                { job.location && (
                                                    <span className="text-truncate me-3"><i className="fa fa-map-marker-alt text-primary me-2"></i>{ job.location }</span>
                                                ) }

                                                <span className="text-truncate me-3"><i className="far fa-clock text-primary me-2"></i>{ job.nature.split("_").join(" ").toUpperCase() }</span>
                                                <span className="text-truncate me-0"><i className="far fa-money-bill-alt text-primary me-2"></i>{ `${ job.currency.toUpperCase() } ${ job.salary_from } - ${ job.salary_to }` }</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <button type="button" className={ isPremium ? "btn btn-outline-primary" : "btn premium-bg" }
                                            onClick={ function () {
                                                toggleFollow();
                                            } }
                                            disabled={ following }>{ isFollowing ? "Following" : "Follow" }</button>
                                    </div>
                                </div>

                                <div className="mb-5">
                                    <h4 className="mb-3">Job description</h4>
                                    <div>{ parse(job.description) }</div>
                                </div>

                                { state.user?.id == job.user.id ? (
                                    <>
                                        <div className="">
                                            <h4 className="mb-5">Applicants</h4>

                                            <div className="row mb-5">
                                                <div className="col-md-5">
                                                    <input type="text" className="form-control" placeholder="Search..."
                                                        value={ searchApplicants }
                                                        onChange={ function (event) {
                                                            setSearchApplicants(event.target.value || "");
                                                        } }
                                                        onKeyDown={ function (event) {
                                                            if (event.key === "Enter") {
                                                                fetch();
                                                            }
                                                        } } />
                                                </div>

                                                <div className="col-md-1">
                                                    <button type="button" className="btn btn-primary"
                                                        onClick={ function () {
                                                            fetch();
                                                        } }
                                                        disabled={ loading }>Search</button>
                                                </div>
                                            </div>

                                            { anyApplicantChecked && (
                                                <button type="button" className={ isPremium ? "btn btn-primary mb-3" : "btn premium-bg mb-3" }
                                                    onClick={ function () {
                                                        downloadCVs();
                                                    } }
                                                    disabled={ downloadingCVs }>Download</button>
                                            ) }

                                            <table className="table table-bordered table-responsive">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <input type="checkbox" onClick={ function (event) {
                                                                const applications = document.querySelectorAll("input[type='checkbox'].application");
                                                                for (let a = 0; a < applications.length; a++) {
                                                                    applications[a].checked = event.target.checked;
                                                                }

                                                                setAnyApplicantChecked(event.target.checked);
                                                            } } id="checkbox-all-applicants" />
                                                        </th>
                                                        <th>Applicant</th>
                                                        <th>CV</th>
                                                        <th className={ isPremium ? "" : "premium-bg" }>Status</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    { applications.map(function (application) {
                                                        return (
                                                            <tr key={ `application-${ application.id }` }>
                                                                <td>
                                                                    <input type="checkbox" className="application"
                                                                        value={ application.id }
                                                                        onClick={ function () {
                                                                            const checked = document.querySelectorAll("input[type='checkbox'].application:checked");
                                                                            let isAllChecked = (checked.length == applications.length);
                                                                            document.getElementById("checkbox-all-applicants").checked = isAllChecked;

                                                                            setAnyApplicantChecked(checked.length > 0);
                                                                        } } />
                                                                </td>

                                                                <td>
                                                                    <span>
                                                                        { application.user.profile_image && (
                                                                            <img src={ application.user.profile_image }
                                                                                style={ styles.profileImage } />
                                                                        ) }
                                                                        &nbsp;

                                                                        <Link to={ `/user/${ application.user.id }` }>
                                                                            { application.user.name } ({ application.user.email })
                                                                        </Link>
                                                                    </span>

                                                                    { application.user.about && (
                                                                        <p className="lead mt-3 mb-0">{ application.user.about }</p>
                                                                    ) }
                                                                </td>

                                                                <td>
                                                                    <a href={ application.cv.path }
                                                                        target="_blank">{ application.cv.title }</a>
                                                                </td>

                                                                <td>
                                                                    <select className="form-control"
                                                                        value={ application.status }
                                                                        style={ styles.bgWhite }
                                                                        onChange={ function (event) {
                                                                            const temp = [ ...applications ];
                                                                            for (let a = 0; a < temp.length; a++) {
                                                                                if (temp[a].id == application.id) {
                                                                                    temp[a].status = event.target.value;
                                                                                    break;
                                                                                }
                                                                            }
                                                                            setApplications(temp);
                                                                            changeApplicationStatus(application.id, event.target.value);
                                                                        } }>
                                                                        <option value="">Select Status</option>
                                                                        <option value="applied">Applied</option>
                                                                        <option value="in_review">In-review</option>
                                                                        <option value="shortlisted">Shortlisted</option>
                                                                        <option value="interviewing">Interviewing</option>
                                                                        <option value="accepted">Accepted</option>
                                                                        <option value="not_considered">Not considered</option>
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                        );
                                                    }) }
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                ) : (
                                    <div className="">
                                        <h4 className="mb-4">Apply For The Job</h4>

                                        { state.user == null ? (
                                            <p><Link to="/login">Login</Link> to apply for Job.</p>
                                        ) : (
                                            <form onSubmit={ function (event) {
                                                event.preventDefault();
                                                apply();
                                            } } id="form-apply">
                                                <div className="row g-3">
                                                    <div className="col-12 col-sm-6">
                                                        <select className="form-control bg-white"
                                                            name="cv_id"
                                                            required>
                                                            <option value="">Select CV</option>

                                                            { cvs.map(function (cv) {
                                                                return (
                                                                    <option key={ `cv-${ cv.id }` } value={ cv.id }>
                                                                        { cv.title }

                                                                        { cv.is_default ? " (Default)" : "" }
                                                                    </option>
                                                                );
                                                            }) }
                                                        </select>

                                                        <p className="mt-2">
                                                            <Link to="/cv-manager">Upload CV here</Link>
                                                        </p>
                                                    </div>

                                                    <div className="col-12 col-sm-6">
                                                        <button className="btn btn-primary w-100" type="submit"
                                                            disabled={ applying }>Apply Now</button>
                                                    </div>
                                                </div>
                                            </form>
                                        ) }
                                    </div>
                                ) }
                            </div>
                
                            <div className="col-lg-4">
                                <div className="bg-light rounded p-5 mb-4 wow slideInUp" data-wow-delay="0.1s">
                                    <h4 className="mb-4">Job Summary</h4>
                                    <p><i className="fa fa-angle-right text-primary me-2"></i>Published On: { job.created_at }</p>
                                    <p><i className="fa fa-angle-right text-primary me-2"></i>Vacancy: { job.vacancies } Position</p>
                                    <p><i className="fa fa-angle-right text-primary me-2"></i>Job Nature: { job.nature.split("_").join(" ").toUpperCase() }</p>
                                    <p><i className="fa fa-angle-right text-primary me-2"></i>Salary: { `${ job.currency.toUpperCase() } ${ job.salary_from } - ${ job.salary_to }` }</p>
                                    
                                    <p><i className="fa fa-angle-right text-primary me-2"></i>Type: { job.type.split("_").join(" ").toUpperCase() }</p>

                                    { job.location && (
                                        <p><i className="fa fa-angle-right text-primary me-2"></i>Location: { job.location }</p>
                                    ) }

                                    <p className="m-0"><i className="fa fa-angle-right text-primary me-2"></i>Applicants: { job.applications }</p>

                                    { state.user?.id == job.user.id && (
                                        <p className="mt-3"><i className="fa fa-angle-right text-primary me-2"></i>Views: { job.views }</p>
                                    ) }
                                </div>
                                
                                { (job.user && job.user.about != "") && (
                                    <div className="bg-light rounded p-5 wow slideInUp mt-5" data-wow-delay="0.1s">
                                        <h4 className="mb-4">Company Detail</h4>
                                        <p className="m-0">{ job.user.about }</p>
                                    </div>
                                ) }
                            </div>
                        </div>
                    </div>
                </div>
            ) }
        </>
    );
}

export default JobDetail;